<template>
  <BaseModalSmall
    small
    @close="$emit('close')"
  >
    <Flex direction="column">
      <BaseText>{{ $t('customers.export_type') }}</BaseText>
      <BaseRadio
        v-model="fileType"
        :options="[
          {
            label: 'CSV',
            value: 'csv'
          },
          {
            label: 'XLS',
            value: 'xls'
          }
        ]"
        v-test="'export-file-type-selection'"
      />
      <BaseAlert
        v-if="unleash.isEnabled('AsyncExports')"
        color="info"
        :text="
          $t('customers.async_export_disclaimer', {
            email: company.notificationEmail
          })
        "
      />
      <BaseAlert
        v-if="selectedAmount > 500"
        :text="$t('customers.export_large_data_warning')"
        color="warning"
        :primaryAction="{
          text: $t('global.actions.go_to_page'),
          routerLink: { 
            name: 'admin-export', 
            query: { period: 'lifetime', dataType: 'customers', fileFormat: fileType } 
          }
        }"
        v-test="'export-large-data-warning'"
      />
    </Flex>
    <template #footer>
      <BaseButton
        @click="submit"
        v-test="'export-file'"
      >
        {{ $t('global.actions.export') }}
      </BaseButton>
    </template>
  </BaseModalSmall>
</template>

<script
  setup
  lang="ts"
>
import { useCompanyStore } from '@/stores/company';
import unleash from '@/unleash';

const { company } = useCompanyStore();
const fileType = ref('csv');
const emit = defineEmits(['close', 'submit']);

const totalCount = inject<any>('totalCount');
const selectedCustomers = inject<any>('selectedCustomers');
const selectedAmount = computed(
  () => selectedCustomers?.value?.length || totalCount?.value || 0,
);

const submit = () => {
  emit('submit', fileType.value);
  emit('close');
};
</script>
